import React from "react"
import { List } from "semantic-ui-react"
import { Fortune } from "./Fortune"

export const Footer = ({ text = "" }) => {
    return (
        <React.Fragment>
            <List floated='right' horizontal className='footer'>
              <List.Item><Fortune /></List.Item>
            </List>
            <List horizontal className='footer'>
              <List.Item>&copy; 2022, Twitching of Isaac, by <a href="https://twitch.tv/sublimnl">sublimnl</a></List.Item>
            </List>
        </React.Fragment>
    )
}
